module.exports = "<ez-public-menu></ez-public-menu>\n<router-outlet></router-outlet>\n<ez-loader></ez-loader>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/public/public.component.html
// module id = 540
// module chunks = 0